import $ from 'jquery';
// import { animateCSS } from '~core';

const rootDivId = '#editor-main-menu';
const scrollToTopBtnId = '#editor-loader-scroll-to-top';

const plusPercent = (number, perc) => number + (number / 100) * perc;
// let hasAnimated = false;

export const initScrollToTopArrow = () => {
  $('#editor-loader-scroll-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
  });

  $(window).bind('scroll', () => {
    if (!$(rootDivId).length) {
      return;
    }
    const currentUserScroll = $(window).scrollTop();
    const divTopOffset = $(rootDivId).offset().top;
    const divHeight = $(rootDivId).outerHeight();

    if (
      plusPercent(currentUserScroll, 30) >=
      divTopOffset + divHeight - window.innerHeight
    ) {
      $(scrollToTopBtnId).fadeIn();
      // if (!hasAnimated) {
      //   setTimeout(async () => {
      //     // await animateCSS(scrollToTopBtnId, 'pulse');
      //     hasAnimated = true;
      //   }, 750);
      // }
    } else {
      $(scrollToTopBtnId).fadeOut();
      // hasAnimated = false;
    }
  });
};
